/**
 * LCObjectImage.js
 *
 * @목적 : LCObject를 상속받은 LCObjectImage 클래스입니다. 이미지의 최상위 클래스입니다.
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.21
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util   from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_Image = (function(superclass){

	return class extends superclass {

		constructor(obj) {
			super(obj);

			// [E] obj.res
			if(obj.res == undefined) {
				B_Util.print("[코드모스] => 요청하신 " + obj.id+ " 이미지 객체의 Resource가 없습니다. ");
				return;
			}

			// [S] strResType, object
			this._strResType = B_Define.ARR_RES_TYPE[0];
			this._object = new createjs.Bitmap(this.CODMOS._res[obj.res].result);
			this._container.addChild(this._object);
		}

		// [F] protected

		// @OVERRIDING
		_setArea(w, h) {
			if(super._checkArea(w,h)) {
        if (this.type === 'bg' && !this._object.image.width) this._object.image.width = 850
        if (this.type === 'bg' && !this._object.image.height) this._object.image.height = 1000
				this._object.scaleX = this._w / this._object.image.width;
				this._object.scaleY = this._h / this._object.image.height;
			}
		}

		// @OVERRIDING
		_setPoint(px, py) {
			if(super._checkReg(px, py)) {
				this._object.regX = this._object.image.width  * this._pointX / 100;
				this._object.regY = this._object.image.height * this._pointY / 100;
			}
		}

		// @OVERRIDING
		_getOriginWidth() { return this._object.image.width; }

		// @OVERRIDING
		_getOriginHeight() { return this._object.image.height; }

		/**
		 * [ Function :: _switchImage ]
		 *
		 * @DES :: 이미지 교체하기
		 * @IP1 :: img {dom}
		 * @O.P :: null
		 * @S.E :: 특이사항없음 //
		 */
		_switchImage(img){
			this._object.image = img
		}

	}
});

export default B_Image;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/image/B_Image.js